import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function InfoIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "13"}
      height={height || "13"}
      viewBox="0 0 13 13"
    >
      <path
        id="Caminho_10321"
        data-name="Caminho 10321"
        d="M7.85,5.25h1.3v1.3H7.85Zm0,2.6h1.3v3.9H7.85ZM8.5,2A6.5,6.5,0,1,0,15,8.5,6.5,6.5,0,0,0,8.5,2Zm0,11.7a5.2,5.2,0,1,1,5.2-5.2A5.207,5.207,0,0,1,8.5,13.7Z"
        transform="translate(-2 -2)"
        fill={color || "#bbb"}
      />
    </svg>
  );
}
